export default __webpack_public_path__ + "img/poster.619cd3cd.png";